module.exports = __webpack_public_path__ + "static/media/droplet-white.7a725935.png";